export default __webpack_public_path__ + "images/pictograms/settings.svg?22bfd4a0e28e8720d29f8387f05724a4262e0dced5694b2bf81ff50d1df31486";